import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _omit from "lodash/omit";
import _get from "lodash/get";
import { startFlow, stopFlow, addFlowData, removeFlowData, resetFlow, changeFlowStep } from "../../actions";

var isCorrectFlow = function isCorrectFlow(flowId, reducerFlowId) {
  return flowId === reducerFlowId;
};

export var createIsActive = function createIsActive(reducerFlowId) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _ref = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref.type,
        _ref$payload = _ref.payload,
        payload = _ref$payload === void 0 ? {} : _ref$payload;

    var flowId = _get(payload, 'flowId');

    switch (type) {
      // when a flow is started set the correct flow to active and all others to false
      // we should only ever have one active flow at a time.
      case startFlow.getType():
        return isCorrectFlow(flowId, reducerFlowId);
      // when a flow stops set it inactive. Since we should only ever have one
      // active flow at a time we can just set all flows to false here

      case stopFlow.getType():
        return false;

      default:
        return state;
    }
  };
};
export var createFlowData = function createFlowData(reducerFlowId) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref2.type,
        _ref2$payload = _ref2.payload,
        payload = _ref2$payload === void 0 ? {} : _ref2$payload;

    var flowId = _get(payload, 'flowId');

    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      case startFlow.getType():
        {
          // The `resumeFlow` option allows flow data to carry over from the user's previous attempt
          // (subject to overrides by `initialData`).
          var resumeFlow = _get(payload, 'options.resumeFlow', false);

          var existingData = resumeFlow ? state : {};

          var initialData = _get(payload, 'options.initialData', {});

          return _objectSpread(_objectSpread({}, existingData), initialData);
        }

      case addFlowData.getType():
        {
          var data = payload.data;
          return _objectSpread(_objectSpread({}, state), data);
        }

      case removeFlowData.getType():
        {
          var key = payload.key;
          return _omit(state, key);
        }

      case resetFlow.getType():
        return {};

      default:
        return state;
    }
  };
};
export var createStoppedReason = function createStoppedReason(reducerFlowId) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref3.type,
        _ref3$payload = _ref3.payload,
        payload = _ref3$payload === void 0 ? {} : _ref3$payload;

    var flowId = _get(payload, 'flowId');

    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      case startFlow.getType():
        return null;

      case stopFlow.getType():
        return payload.reason;

      case resetFlow.getType():
        return null;

      default:
        return state;
    }
  };
};
export var createStep = function createStep(reducerFlowId) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _ref4 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref4.type,
        _ref4$payload = _ref4.payload,
        payload = _ref4$payload === void 0 ? {} : _ref4$payload;

    var flowId = _get(payload, 'flowId');

    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      // When a flow gets stopped the current step is cleared
      case stopFlow.getType():
        return null;

      case changeFlowStep.getType():
        {
          var step = payload.step,
              direction = payload.direction; // when a flow has no more steps to show it dispatches an empty changeFlowStep action

          return step ? _objectSpread(_objectSpread({}, step), {}, {
            direction: direction
          }) : null;
        }

      default:
        return state;
    }
  };
};
export var createFlowConfig = function createFlowConfig(reducerFlowId) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _ref5 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref5.type,
        _ref5$payload = _ref5.payload,
        payload = _ref5$payload === void 0 ? {} : _ref5$payload;

    var flowId = _get(payload, 'flowId');

    if (!isCorrectFlow(flowId, reducerFlowId)) return state;

    switch (type) {
      case stopFlow.getType():
      case resetFlow.getType():
        return null;

      case startFlow.getType():
        return payload.options;

      default:
        return state;
    }
  };
};
export default (function (reducerFlowId) {
  return {
    isActive: createIsActive(reducerFlowId),
    data: createFlowData(reducerFlowId),
    config: createFlowConfig(reducerFlowId),
    step: createStep(reducerFlowId),
    stoppedReason: createStoppedReason(reducerFlowId)
  };
});